import posters from "@/data/service-posters.json";

type Candidate = { src: string; width: number; height: number };
type PosterFormats = { avif: Candidate[]; webp: Candidate[] };

export function getResponsivePoster(src: string) {
  const formats = (posters as Record<string, PosterFormats>)[src];
  if (!formats) return undefined;
  return {
    avifSrcSet: formats.avif.map(image => `${image.src} ${image.width}w`).join(", "),
    avifSrc: formats.avif[0].src,
    webpSrcSet: formats.webp.map(image => `${image.src} ${image.width}w`).join(", "),
    fallback: formats.webp[0],
  };
}

/** Match the picture exactly for React DOM's deduplicated head resource hint. */
export function getResponsivePosterPreload(src: string, sizes: string) {
  const poster = getResponsivePoster(src);
  if (!poster) return undefined;
  return {
    as: "image" as const,
    type: "image/avif",
    href: poster.avifSrc,
    imageSrcSet: poster.avifSrcSet,
    imageSizes: sizes,
    fetchPriority: "high" as const,
  };
}
